import { t } from 'i18n';
import { LocationOutlined } from '@teko/ds-icon';
import { Body, Popover, styled, Row, Col, BaseProps } from '@teko/ds-desktop';
import { useState } from 'react';

interface Props {
  active: boolean;
  children: React.ReactElement;
  onClose: () => void;
  isMobile?: boolean;
}

const StyledPopover = styled(Popover)(
  ({ minWidth }: { minWidth: string }) => `
    box-shadow: 2px 4px 5px grey;
    min-width: ${minWidth};
    z-index: 1060;
  `,
);

export const RegionPickerSuggestionPopover: React.FC<BaseProps & Props> = ({
  active,
  onClose,
  isMobile,
  children,
}) => {
  const [show, setShow] = useState(active);

  const closePopover = () => {
    setShow(false);
    onClose();
  };

  return (
    <StyledPopover
      title={
        <Row align="middle" justify="center">
          <Col flex="5%" paddingRight="s8">
            <LocationOutlined size={26} color="primary500" />
          </Col>
          <Col flex="80%">
            <Body level={1} color="textSecondary">
              {t(
                'Hãy chọn địa chỉ cụ thể để chúng tôi cung cấp chính xác giá và khuyến mãi.',
              )}
            </Body>
          </Col>
        </Row>
      }
      placement={isMobile ? 'bottom-start' : 'bottom-end'}
      backgroundColor="white"
      borderRadius="l"
      borderStyle="solid"
      borderWeight="m"
      borderColor="border"
      showArrow={isMobile ? true : false}
      buttonText={t('Đóng')}
      show={show}
      buttonAlign="center"
      buttonVariant="primary"
      padding="s8"
      minWidth={isMobile ? '56vw' : '19rem'}
      onClickButton={closePopover}
    >
      <div onClick={closePopover}>{children}</div>
    </StyledPopover>
  );
};
